export default [

    {
        path: "/registration/procuring-entity-registration-details",
        name: "procuring-entity-registration-details",
        meta: { title: "procuring-entity-registration-details", authRequired: true },
        component: () => import("../views/registration/procuring-entity-registration-details.vue"),
    },
    {
        path: "/registration/procuring-entity-supplier-registration",
        name: "procuring-entity-supplier-registration",
        meta: { title: "procuring-entity-supplier-registration", authRequired: true },
        component: () => import("../views/registration/procuring-entity-supplier-registration.vue"),
    }
]